import * as types from "../../constants";

export default function reducer(state = {}, actions) {
  switch (actions.type) {
    case types.AUTH_SIGN_IN_SUCCESS:
      return {
        ...state,
        user: {
          id: actions.id,
          email: actions.email,
          name: actions.name,
        },
      };

    case types.AUTH_SIGN_OUT:
        // BUG C defensive fix: don't nuke the whole localStorage on sign-out.
        //
        // The original `localStorage.clear()` wiped EVERY key, including
        // `sherwoodDiagSessionId` (so diagnostic continuity is lost across
        // sign-outs) and — critically — any third-party state that has no
        // business being wiped by our auth flow.
        //
        // ATTADIR on chom-dakar hit this today: a spurious AUTH_SIGN_OUT
        // fired ~1s after a successful login on `/` and wiped rawKeyResearcher,
        // breaking patient-data decryption (the Storage Proxy diagnostic
        // captured the stack: rJi → 379:10312 → h:379:8307 — TBD in source).
        //
        // Targeted removeItem means that even if a stray sign-out still fires,
        // only known auth keys are affected — nothing else. We still need to
        // root-cause WHO is dispatching AUTH_SIGN_OUT on that route; this fix
        // just reduces the blast radius while we investigate.
        try {
            // All keys that the sign-in flow writes. Review-agent catch:
            // `keyResearcher` is still written by src/actions/index.js:22
            // (legacy path) and `type` by src/components/dashboard/login.jsx:65
            // — both were previously cleared by the blanket .clear() call, so
            // keep parity.
            localStorage.removeItem('jwt');
            localStorage.removeItem('password');
            localStorage.removeItem('rawKeyResearcher');
            localStorage.removeItem('keyResearcher');
            localStorage.removeItem('type');
        } catch (_) { /* ignore: localStorage may be unavailable in SSR/tests */ }
        return {
            ...state,
            user: undefined,
        };

    default:
      return state;
  }
}
